import Qs from 'qs'
import store from '../store/index'
import jsonp from 'jsonp'
import { sc } from '@/utils/storage'
import match from 'js-pattern-matching'

const getEnv = require('../../get-env')
const ENV = getEnv()

// 区分切片PC和h5埋点
const getTrackPlatformId = () => {
  const currentPageUrl = window.location.href
  if (currentPageUrl.includes('/h5/')) {
    return 10032 // h5
  } else {
    return 10021 // pc
  }
}

//从jsonp接口请问游客id
try {
  jsonp('https://analysis.chanmama.com/v1/jsonp', {}, (err, cid) => {
    if (err) {
      return
    }
    sc('CMM_A_C_ID', cid)
  })
} catch (e) {
  console.log(e)
}

function getCommonParams(isPost = false) {
  return {
    [isPost ? 'token' : 't']: store?.state?.user?.token,
    [isPost ? 'site_id' : 'si']: 'cmm_jx',
    [isPost ? 'platform' : 'p']: getTrackPlatformId(),
    [isPost ? 'refer' : 'r']: document?.referrer
  }
}

export function pushEvent(action, params = {}) {
  try {
    const body = {
      ...getCommonParams(),
      a: action.toString(),
      js: JSON.stringify(params)
    }
    const host = 'https://analysis.chanmama.com/rt.gif'
    const par = Qs.stringify(body)
    const url = `${host}?${par}`
    const img = new Image()
    img.src = url
  } catch (e) {
    console.log(e)
  }
}

function getReportDomain() {
  return match(ENV)(
    (v = 'dev') => 'https://cmm-analysis-test.cds8.cn',
    (v = 'test') => 'https://cmm-analysis-test.cds8.cn',
    (v = 'stage') => 'https://analysis.chanmama.com',
    (v = 'prod') => 'https://analysis.chanmama.com'
  )
}

export function postEvent(action, params = {}) {
  if (['dev', 'test'].includes(ENV)) {
    console.warn('因后端不区分测试环境数据，拦截测试环境的埋点上报')
    return
  }
  try {
    const body = {
      ...getCommonParams(true),
      action: action.toString(),
      attributes: params
    }
    const host = `${getReportDomain()}/v1/report`

    const xhr = new XMLHttpRequest()
    xhr.open('POST', host, true)
    xhr.setRequestHeader('content-type', 'application/json')
    //将用户输入值序列化成字符串
    xhr.send(JSON.stringify(body))
  } catch (e) {
    console.log(e)
  }
}
